export enum DeviceTypeOPEEnum {
  GetDeviceTypes = 'getDeviceTypes',
  GetDeviceType = 'getDeviceType',
  PutDeviceType = 'putDeviceType',
  DelDeviceType = 'delDeviceType',
  DuplicateDeviceType = 'duplicateDeviceType'

}
